import { BinaryWriter } from "../binary.js";
import { ClientOp } from "../opcodes.js";
export function encodeAttack(packet, writer = new BinaryWriter(8)) {
    writer.u8(ClientOp.Attack).u32(packet.targetId);
    return writer;
}
export function decodeAttack(reader) {
    return { targetId: reader.u32() };
}
//# sourceMappingURL=attack.js.map